//Format Method
const FormatCurrency = (price, cultureCode, currency, minDigits, maxDigits) => {
    price = price || 0;
    let formattedCurrency = getFormatter(cultureCode, currency, minDigits, maxDigits).format(price);
    formattedCurrency = formattedCurrency.replace(/\s/g, '');
    return formattedCurrency.includes("NaN") ? price : formattedCurrency;
};

const formatBidAmount = (amount, currencyCode, cultureCode) => {
    const formattedAmount = FormatCurrencyWihtoutSymbol(amount, cultureCode, currencyCode, 2, 2);
    const currencySymbol = GetCurrencySymbolFromCurrencyValue(FormatCurrency(0, cultureCode, currencyCode, 2, 2));

    return `${currencyCode?.toUpperCase()} ${currencySymbol}${formattedAmount}`;
};

const FormatCurrencyWihtoutSymbol = (price, cultureCode, currency, minDigits, maxDigits) => {
    if (price) {
        return GetCurrencyWithoutSymbol(FormatCurrency(price, cultureCode, currency, minDigits, maxDigits));
    }
    return price;  
};

const SwapCurrencyFormat = (price, previousCultureCode, previousCurrency, newCultureCode, newCurrency, minDigits, maxDigits, isPercentage = false) => {
    if (price) {
        if (!isPercentage) {
            return FormatCurrency(UnformatCurrency(price, previousCultureCode, previousCurrency), newCultureCode, newCurrency, minDigits, maxDigits);
        } else {
            return FormatCurrencyWihtoutSymbol(UnformatCurrency(price, previousCultureCode, previousCurrency), newCultureCode, newCurrency, minDigits, maxDigits) + "%";
        }
    }
    return price;
};

//return currency to orginal decimal format
const UnformatCurrency = (price, cultureCode, currency, returnOriginalValue, skipDecimalChar) => {
    if (price) {
        let originalString = (' ' + price).slice(1);
        let currentFormat = FormatCurrency(0, cultureCode, currency)
        let currentFormatWithoutSymbol = GetCurrencyWithoutSymbol(currentFormat);
        let decimalDelimiter = currentFormatWithoutSymbol.includes("0.00") ? "." : ",";
        let unformattedPrice = parseFloat(decimalDelimiter != ',' ?
            price.toString()               // if decimal separator is a '.' or a '$'
                .replace(/\$/g, '.').toString()	    // remove '$' if its a separator and replace with '.'
                .replace(/[^\d.]/g, '').toString()	// remove non-numeric signs except '.'
                .replace(/^\.+|\.+$/, '')			// remove any leading and trailing '.'
            :
            skipDecimalChar ?
                price.toString()               // if decimal separator is a ','
                    .replace(/[^\d]/g, '').toString()	// remove non-numeric signs
                :
            price.toString()               // if decimal separator is a ','
                .replace(/[^\d,]/g, '').toString()	// remove non-numeric signs except ','
                .replace(decimalDelimiter, '.'));	// replace separator ',' with '.'
        return unformattedPrice || (returnOriginalValue ? originalString : "");
    }
    return price;
};

const GetCurrencySymbolFromCurrencyValue = (price) => {
    if (price) {
        let currencySymbol = '';
        let prevChar = 'x';
        let forwardChar = 'x';
        for (let i = 0; i < price.length; i++) {
            if (i > 0)
                prevChar = price.charAt(i - 1);
            if (i < price.length - 1)
                forwardChar = price.charAt(i + 1);

            if (!isNaN(parseInt(prevChar, 10)) && !isNaN(parseInt(forwardChar, 10)) && price.charAt(i) == '.') { }
            else { currencySymbol += price.charAt(i); }
        }
        return String(currencySymbol.toString().replace(/[0-9\s,A-Za-z]/g, ''));
    }
    return price;
};

const GetCurrencyWithoutSymbol = (price) => {
    if (price) {
        return String(currencyExtractor().exec(price.replace(/\s/g, '').replace(GetCurrencySymbolFromCurrencyValue(price), '')));
    }
    return price;
};

///////////////////////////////////
// The below functions are helpers not meant to be used outside this file, don't export these
///////////////////////////////////

//regex matching
const currencyExtractor = () => /\d*\,?\d*\.?\d*$/;

//Intl.NumberFormat get
const getFormatter = (cultureCode, currency, minDigits, maxDigits) => {
    return new Intl.NumberFormat(cultureCode, {
        style: 'currency',
        currency: currency,       
        minimumFractionDigits: minDigits || 2,
        maximumFractionDigits: maxDigits || 2,
        trailingZeroDisplay: (minDigits == 0 && maxDigits == 0) ? 'stripIfInteger' : 'auto',
    });
};

export {
    FormatCurrency,
    formatBidAmount,
    FormatCurrencyWihtoutSymbol,
    SwapCurrencyFormat,
    UnformatCurrency,
    GetCurrencySymbolFromCurrencyValue,
    GetCurrencyWithoutSymbol
};